import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface UserState {
  videoComplete?: boolean;
  purlLoginComplete?: boolean;
  purlInviteSent?: boolean;
  presentationComplete?: boolean;
  benefitCalculatorComplete?: boolean;
  cpaCallComplete?: boolean;
  softCommitComplete?: boolean;
  entityInformationCollected?: boolean;
  purlNdaChecked?: string | null;
  zohoCustomerId?: string;
  formData?: Object;
  billOfSaleSignedDate?: Date | null;
  zohoTrancheId?: string | null;
}

type Props = {
  data?: {
    data?: {
      data?: FormResponse;
      message: string;
      success: boolean;
    };
  };
};

const initialState: UserState = {
  videoComplete: false,
  purlLoginComplete: false,
  purlInviteSent: false,
  presentationComplete: false,
  benefitCalculatorComplete: false,
  cpaCallComplete: false,
  softCommitComplete: false,
  entityInformationCollected: false,
  purlNdaChecked: null,
  zohoCustomerId: "",
  formData: {},
  billOfSaleSignedDate: null,
  zohoTrancheId: null,
};

export const stageSlice = createSlice({
  name: "stage",
  initialState,
  reducers: {
    setStage: (state, action: PayloadAction<UserState>) => {
      const {
        videoComplete = false,
        purlLoginComplete = false,
        purlInviteSent = false,
        presentationComplete = false,
        benefitCalculatorComplete = false,
        cpaCallComplete = false,
        softCommitComplete = false,
        entityInformationCollected = false,
        purlNdaChecked = null,
        zohoTrancheId = null,
        billOfSaleSignedDate = null,
      } = action.payload || {};

      Object.assign(state, {
        videoComplete,
        purlLoginComplete,
        purlInviteSent,
        presentationComplete,
        benefitCalculatorComplete,
        cpaCallComplete,
        softCommitComplete,
        entityInformationCollected,
        purlNdaChecked,
        zohoTrancheId,
        billOfSaleSignedDate,
      });

      return state;
    },
    updateFormData: (state, action: PayloadAction<any>) => {
      state.formData = action.payload;
      return state;
    },
  },
});

export const { setStage, updateFormData } = stageSlice.actions;
export const selectFormData = (state: any) => state.stage?.formData;

export default stageSlice.reducer;
